
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/joinus",
      function () {
        return require("private-next-pages/joinus/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/joinus"])
      });
    }
  